module.exports = __webpack_public_path__ + "img/1534754260.0bdd8289.jpg";